export default function InvoiceFilters({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  onSearch,
  onClear,
}) {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  return (
    <div>
      {/* Date box */}
      <div className="invoice-filters">
        <div className="filters-row">
          <div className="form-group">
            <label className="form-label">📅 Start Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="form-label">📅 End Date</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div className="filters-actions">
            <button className="btn btn-primary" onClick={onSearch}>
              🔍 Search
            </button>
            <button className="btn btn-secondary" onClick={onClear}>
              🔄 Clear
            </button>
          </div>
        </div>

        {fromDate && toDate && (
          <div className="alert alert-info">
            <span>
              📊 Searching invoices from <strong>{formatDate(fromDate)}</strong> to{' '}
              <strong>{formatDate(toDate)}</strong>
            </span>
          </div>
        )}
      </div>
    </div>
  );
}